import { render } from "./airqualitynpForecast.vue?vue&type=template&id=6d42b685"
import script from "./airqualitynpForecast.vue?vue&type=script&lang=js"
export * from "./airqualitynpForecast.vue?vue&type=script&lang=js"

import "./airqualitynpForecast.vue?vue&type=style&index=0&id=6d42b685&lang=scss"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__